
export default class Request {

    Id: string;
    CreatedDate: Date | undefined;
    CreatedDateToFormatted: string | undefined;
    RequestStateName: string | undefined;
    RequestStateNameToExibition: string | undefined;
    Protocol: string | undefined;
    RequestState: number | undefined;
    ColorStatus: string | undefined;
    ConclusionDate: Date | undefined;
    ConclusionDateToFormatted: string | undefined;


    constructor(id: string) {
        this.Id = id;
    }

    static NewInstance() {
        return new Request("");
    }
}